import { Observable } from "rxjs";
import {
  AgreementData,
  EditAgreementHeader,
  SaveAgreementDTO,
} from "../models/agreement.model";
import { PlanningWizardDTO } from "../models/planning-wizard.model";

export abstract class AgreementRepository {
  abstract updatePETC(
    agreementHeader: EditAgreementHeader,
  ): Observable<boolean>;
  abstract editNotes(id: number, note: string): Observable<string>;
  abstract loadAgreement(
    agreementId: number,
    level: number,
  ): Observable<AgreementData>;
  abstract save(smartsToCreate: SaveAgreementDTO[]): Observable<boolean>;
  abstract publishOpportunity(
    agreementId: number,
  ) // smartsToCreate: SaveAgreementDTO[],
  : Observable<boolean>;
  abstract changeStatus(agreementId: number): Observable<string>;
  abstract createWorkloadFromOpportunity(
    agreementId: number,
    wizardValue: PlanningWizardDTO,
  ): Observable<boolean>;
}
